"use strict";
import './assets/css/vendor/normalize.min.css';
// import './assets/css/vendor/plyr.css';
import './assets/css/vendor/swiper.css';
import './assets/js/vendor/modernizr.js';
import './assets/css/main.css';
import './assets/js/polyfills.js';
import Site from './assets/js/main.js';

const siteInstance = new Site(window._pageSetup || {});
